var _style, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Share_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Share_svg__st1{fill-rule:evenodd;clip-rule:evenodd}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share_svg__Stroke",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Share_svg__Stroke-Copy",
    d: "M30 0c16.6 0 30 13.4 30 30S46.6 60 30 60 0 46.6 0 30 13.4 0 30 0z",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Share_svg__st1",
    fill: "currentColor",
    d: "M43.7 25.3h-5v2.5h5.8v20h-25v-20h5.8v-2.5h-5c-1.8 0-3.3 1.5-3.3 3.3V47c0 1.8 1.5 3.3 3.3 3.3h23.4c1.8 0 3.3-1.5 3.3-3.3V28.6c0-1.8-1.5-3.3-3.3-3.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Share_svg__st1",
    fill: "currentColor",
    d: "M27.6 21.1l3.2-3.2v17.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3V18l3.2 3.2c.5.5 1.3.5 1.8 0s.5-1.3 0-1.8l-5.3-5.3c-.5-.5-1.3-.5-1.8 0L26 19.4c-.5.5-.5 1.3 0 1.8.3.4 1.1.4 1.6-.1z"
  })));
};
export default SvgShare;